module.exports = __webpack_public_path__ + "static/media/success-story-persons.8fceee3f.png";